<template>
  <div @click.stop="null" id="input-label" class="ant-input input-label">
    <div v-for="label in value" :key="label" class="label">
      <a-tooltip :getPopupContainer="getPopupContainer">
        <template slot="title"> {{ label }} </template>
        <span>{{ label }}</span>
      </a-tooltip>
      <a-icon @click="removeLabel(label)" type="close" class="icon" :style="{ fontSize: '10px' }" />
    </div>
    <div @input="onInput" @focus="focus" :focus="open" contenteditable class="input" @keydown="onKeydown($event)"></div>
    <span class="placeholder" v-if="showPlaceholder" :key="inputValue">请输入标签</span>
    <a-tree-select
      :value="selectTree"
      :getPopupContainer="getPopupContainer"
      :open="open"
      ref="tree-select"
      :replaceFields="replaceFields"
      :multiple="true"
      mode="multiple"
      :tree-data="options"
      :treeExpandedKeys.sync="treeExpandedKeys"
      :maxTagCount="5"
      @change="select"
      :maxTagTextLength="10"
    >
    </a-tree-select>
  </div>
</template>
<script>
export default {
  name: 'InputLable',
  model: {
    event: 'input',
  },
  computed: {
    showPlaceholder() {
      return !this.inputValue && this.inputValue !== 0 && !this.value?.length
    },
  },
  props: {
    value: {
      type: Array,
      default: [],
    },
    replaceFields: {
      type: Object,
      default: () => ({ title: 'name', key: 'id', value: 'id' }),
    },
    options: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      inputValue: '',
      open: false,
      selectTree: [],
      treeExpandedKeys: [],
    }
  },
  methods: {
    isRepeat(label) {
      return this.value.some((item) => item === label)
    },
    focus() {
      this.open = true
      window.addEventListener(
        'click',
        (e) => {
          this.selectTree = []
          this.treeExpandedKeys = []
          this.open = false
        },
        { once: true }
      )
    },

    getPopupContainer() {
      return document.getElementById('input-label')
    },
    removeLabel(label) {
      const value = this.value.filter((v) => v != label)
      this.$emit('remove', label, value)
      this.$emit('input', value)
    },
    onInput(e) {
      this.inputValue = e.target.textContent
      if (this.inputValue === '') {
        e.target.innerHTML = ''
      }
    },
    onKeydown(e) {
      if (e.keyCode == 13 && !e.shiftKey) {
        e.preventDefault()
        if (this.isRepeat(e.target.textContent)) {
          return this.$message.error('标签重复')
        }
        this.value.push(e.target.textContent)
        e.target.innerHTML = ''
        this.inputValue = ''
        this.$emit('change', e.target.textContent, this.value)
        this.$emit('input', this.value)
      }
    },
    select(value, node, e) {
      const { preValue = [], triggerNode } = e
      if (this.selectTree.includes(triggerNode.value)) {
        this.selectTree = this.selectTree.filter((item) => item != triggerNode.value)
        const value = this.value.filter((v) => v != triggerNode.title)
        this.$emit('input', value)
        return
      }
      if (this.isRepeat(triggerNode.title)) {
        return this.$message.error('标签重复')
      }
      this.value.push(...node.filter((title) => !preValue.some((item) => item.label == title)))
      this.selectTree = value
      this.$emit('input', this.value)
    },
  },
}
</script>
<style lang="less" scoped>
.input-label {
  height: auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 4px 0;
  position: relative;
  .label {
    display: inline-block;
    position: relative;
    padding: 0 10px;
    padding-right: 20px;
    box-sizing: border-box;
    background-color: #fafafa;
    border: 1px solid #e8e8e8;
    border-radius: 2px;
    font-size: 14px;
    height: 24px;
    margin-right: 4px;
    line-height: 22px;
    flex-shrink: 0;
    cursor: pointer;
    max-width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 4px;
    }
  }
  .input {
    outline: none;
    flex: 1;
    position: relative;
    min-width: 20%;
    z-index: 99;
  }
  .placeholder {
    position: absolute;
    color: #bfbfbf;
    pointer-events: none;
  }
  br {
    display: none !important;
  }
  ::v-deep .ant-select-enabled {
    // display: none;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    visibility: hidden;
    height: 100%;
  }
  ::v-deep .ant-select-dropdown .ant-select-tree {
    max-height: 468px;
    overflow-y: auto;
  }
}
</style>
